export default function standardFormat(n: number): string {
  // TODO: Insert commas?
  return n.toString();
}
